module.exports = __webpack_public_path__ + "static/media/ppa-logo.e9c337d0.svg";